import { render, staticRenderFns } from "./collectionNotice.vue?vue&type=template&id=3923eee3&scoped=true"
import script from "./collectionNotice.vue?vue&type=script&lang=js"
export * from "./collectionNotice.vue?vue&type=script&lang=js"
import style0 from "./collectionNotice.vue?vue&type=style&index=0&id=3923eee3&prod&lang=scss&scoped=true"
import style1 from "./collectionNotice.vue?vue&type=style&index=1&id=3923eee3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3923eee3",
  null
  
)

export default component.exports